// extracted by mini-css-extract-plugin
export var chip = "_9u-0";
export var filterDropdown = "_9u-5";
export var filterItem = "_9u-6";
export var icon = "_9u-1";
export var removeButton = "_9u-3";
export var removeIcon = "_9u-4";
export var separator = "_9u-2";